import('./map_scale.scss')

export default function MapScale(opts={}){
    BaseConstructor.call(this)
    let {map, options} = opts
    let elements = {}
    let context = this

    
    init()
    
    function init(){
        L.control.scale({imperial:false,position:options.position}).addTo(map);

    }
}

MapScale.prototype = Object.create(BaseConstructor.prototype)